export const UI_LANGUAGES = ["en", "pt-BR"] as const;

export type UiLanguage = (typeof UI_LANGUAGES)[number];

export function isUiLanguage(value: string | null | undefined): value is UiLanguage {
  return value === "en" || value === "pt-BR";
}

export function normalizeUiLanguage(input: string | null | undefined): UiLanguage {
  if (!input) return "en";
  const tag = input.replace("_", "-").toLowerCase();
  if (tag === "pt" || tag.startsWith("pt-")) return "pt-BR";
  if (tag === "en" || tag.startsWith("en-")) return "en";
  return "en";
}
